module.exports = __webpack_public_path__ + "img/icon_bellSolid.65759dd1.svg";